<template>
    <div class="get_order_sync">
        <div class="panel-container-org " v-if="!show_feed">
            <b-overlay key="main_loader" :show="!auth_obj.isLoaded" rounded="sm">
                <template v-slot:overlay>
                    <div class="text-center">
                        <b-icon icon="stopwatch" font-scale="2" animation="cylon"></b-icon>
                        <p id="cancel-label">
                            <b-badge variant="primary" pill v-if="auth_obj.isRunning">
                                {{ auth_obj.step_name }} : {{ __t('TIME') }} {{ timer.seconds }}
                            </b-badge>
                        </p>
                    </div>
                </template>

                <div class="work_area">
                    <div class="panel-tag word-break" v-if="auth_obj.token != null">
                        API info: {{ auth_obj.token }}
                    </div>

                    <div class="feed_block_standart" v-if="!is_barsi_meal">
                        <!--
                       <div class="panel-tag word-break" v-if="parseInt(this.last_task.id) > 0">
                            <div v-if="this.last_task.hasOwnProperty('added')">
                                LAST_UPDATE: {{this.last_task.added}}
                            </div>
                        </div>
    -->
                        <h3 class="pb-2" v-if="cur_step == 'orgs_loaded'">
                            {{ __t(provider.type.toUpperCase() + '_SELECT_ORG') }}
                        </h3>

                        <div class="lot_or">
                            <div class="form-group mt-2 org_item" v-for="(org,idx) in worked_orgs">
                                <div class="input-group input-group-lg">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text ">
                                            <bounce-loader :loading="org.is_loading" size="10px"></bounce-loader>
                                            <i class="fal fa-building" v-if="!org.is_loading"></i>
                                        </div>
                                    </div>

                                    <div class="form-control">
                                        <div class="custom-control custom-checkbox">
                                            <input type="checkbox"
                                                   v-model="org.is_selected"
                                                   :disabled="org.is_loading"
                                                   @input="set_active_org(org)"
                                                   class="custom-control-input" :id="org.id">
                                            <label class="custom-control-label" :for="org.id">
                                                {{ org.title }}
                                            </label>
                                        </div>
                                    </div>
                                    <div class="input-group-append">
                                        <input type="text" v-model="org.id" disabled class="text-center fs-xl" >
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div class="external_params mt-3" v-if="has_external_menu">
                            <h3 class="pb-2">
                               {{__t('POS.SELECT_EXTERNAL_MENU')}}
                            </h3>

                            <v-select
                                v-model="externalMenuId"
                                :reduce="item => String(item.id)"
                                label="name"
                                :options="this.active_org.external_menu" >
                            </v-select>
                        </div>


                        <div class="different_price_org pt-5" v-if="!has_external_menu" >
                            <yes_no
                                key="DIFFERENT_PRICE_ON_SAME_MENU"
                                title="DIFFERENT_PRICE_ON_SAME_MENU"
                                @input="on_set_different_prices"
                                v-model="show_diff_price"
                            >
                            </yes_no>
                            <b-overlay key="org_list_all" :show="is_load_all_org" rounded="sm">
                                <div class="form-group mt-2 org_item" v-for="(org,idx) in draw_all_org">
                                    <div class="input-group input-group-lg">
                                        <div class="input-group-prepend">
                                            <div class="input-group-text ">
                                                <i class="fal fa-building"></i>
                                            </div>
                                        </div>

                                        <div class="form-control">
                                            <div class="custom-control custom-checkbox">
                                                <input type="checkbox"
                                                       v-model="org.is_selected"
                                                       class="custom-control-input" :id="'_' + org.id" />

                                                <label class="custom-control-label" :for="'_' + org.id">
                                                    {{ org.title }}
                                                </label>
                                            </div>
                                        </div>

                                        <div class="input-group-append">
                                            <input type="text" v-model="org.id" disabled class="text-center fs-xl" >
                                        </div>
                                    </div>
                                </div>
                            </b-overlay>
                        </div>
                    </div>

                    <div class="feed_barsi" v-else>
                        <fileload @finish_load="finish_load" :doc_id="prov_id" doc_type="feed" :url_load="'pos/upload/feed'"></fileload>
                    </div>

                </div>

                <div class="buttons mt-5 pt-5" v-if="!is_barsi_meal">
                    <button class="btn btn-lg btn-outline-primary waves-effect waves-themed" v-on:click="go_sync" :disabled=can_sync>
                        <span class="fal" :class="{'fa-check mr-1' : !can_sync, 'fa-exclamation-triangle' : can_sync}"></span>
                        {{ __t('CONTINUE') }}
                    </button>

                    <button class="btn btn-lg btn-outline-warning waves-effect waves-themed ml-5" v-on:click="go_start" :disabled=!can_sync>
                        <span class="fal" :class="{'fa-check mr-1' : can_sync, 'fa-exclamation-triangle' : !can_sync}"></span>
                        {{ __t('BACK') }}
                    </button>
                </div>


            </b-overlay>
        </div>
        <!-- pos_worker -->
        <pos_sync_feed :external_menu_id="external_menu_id" :child_organizations="prices_orgs_ids" :selected_org="active_org.uniq_id" v-if="show_feed"></pos_sync_feed>
    </div>
</template>

<script>


import BounceLoader from 'vue-spinner/src/BounceLoader.vue'
import Spinner from 'vue-simple-spinner';
import {mapGetters} from "vuex";
import Pos_sync_feed from "./pos_sync_feed";
import yes_no from "../../sys/radio/yes_no.vue";
import vSelect from 'vue-select';
import Fileload from "../../sys/file_loader/fileload.vue";


export default {
    name: "pos_sync",
    components: {
        yes_no,
        Pos_sync_feed,
        Spinner,
        BounceLoader,
        vSelect,
        Fileload
    },

    data() {
        return {
            is_auth: false,
            show: true,

            menu_loading: {
                isRunning: false,
            },

            timer: {
                seconds: 0,
                interval: null,
            },

            last_task : {
                "id" : 0,
            },

            cur_step: "wait_org_list",
            show_feed: false,
            show_diff_price : false,

            orgs: [],
            all_organization : [],
            is_load_all_org : false,

            auth_obj: {
                step_name: "",
                isRunning: false,
                isLoaded: false,
                request_cancel: null,
                token: null,
            },
            last_params : {

            },
            external_menu_id : 0,
        }
    },

    mounted () {
        this.get_params();
        this.init_socket();
    },

    methods : {

        finish_load(file) {

            console.log('go_next_step',file);
            this.pos_item.is_init = true;
            this.$store.dispatch('pos/SET_LOAD_COMPLETE',true);

            this.pos_item.pos_params.extra_request = {
                "file" : file
            };

            this.go_sync();
        },

        get_lats_params() {

            pos_api.get('/pos/' + this.prov_id + '/feed/last').then(({data}) => {
                if (data.status === "operation_success") {
                    this.last_params = data.data;

                    const activeOrg = this.orgs.find(item => item.is_active);

                    if (activeOrg) {
                        this.set_active_org(activeOrg);
                    } else if (this.last_params.hasOwnProperty('main_organization_uniq_id')) {

                        const lastOrg = this.orgs.find(item =>
                            String(item.uniq_id ?? item.id) ===
                            String(this.last_params.main_organization_uniq_id)
                        );

                        if (lastOrg) {
                            this.set_active_org(lastOrg);
                        }
                    }

                    let childIds = this.get_last_child_organization_ids();

                    if (childIds.length > 0) {
                        this.show_diff_price = true;
                        this.on_set_different_prices(true);
                    }
                    else {

                        let externalMenuId = this.last_params.extra_params?.params?.external_menu_id || null;

                        if (externalMenuId) {
                            this.external_menu_id = String(externalMenuId);
                        }
                    }
                }
            })
            .catch(({response}) => {
                EventBus.$emit('show_toast', {
                    err: response.data.message,
                    type: "danger",
                    title: response.data.status
                })
            });
        },

        get_last_child_organization_ids() {
            let ids = [];

            if (this.last_params.hasOwnProperty('child_organizations')) {
                ids = this.last_params.child_organizations || [];
            }

            if (
                this.last_params.hasOwnProperty('extra_params') &&
                this.last_params.extra_params.hasOwnProperty('params') &&
                this.last_params.extra_params.params.hasOwnProperty('child_ids')
            ) {
                ids = this.last_params.extra_params.params.child_ids || ids;
            }

            return ids.map(id => String(id));
        },


        init_socket() {
            try {
                window.Echo.private("feed." + this.user.client_id)
                    .listen('.task.' + this.prov_id, (event) => {
                        console.log('feed_event',event);
                        EventBus.$emit('provider_task_' + this.prov_id,event);
                    }).error((error) => {
                        console.error("Ошибка при подписке на WebSocket:", error);
                    })
            }
            catch (e) {
                console.log('err',e);
            }


            try {
                window.Echo.private("pos." + this.user.client_id)
                    .listen('.log', (event) => {
                        if(event.hasOwnProperty("type")) {
                            let type = event.type;

                            if(type === 'error') {
                                this.__l(event, "warn", "# ---------->  FEED_LOG");
                            }
                            else {
                                this.__l(event, "info", "# ---------->  FEED_LOG");
                            }
                        }

                    }).error((error) => {
                        console.error("Ошибка при подписке на WebSocket:", error);
                    })
            }
            catch (e) {
                console.log('err',e);
            }
        },

        on_set_different_prices(val) {
            if (!val) {
                this.all_organization = [];
                return;
            }

            // Не запускаем второй параллельный запрос
            if (this.is_load_all_org) {
                return;
            }

            this.is_load_all_org = true;

            pos_api.get('/pos/' + this.prov_id + '/organizations/all')
                .then(({ data }) => {
                    if (data.status !== 'operation_success') {
                        return;
                    }

                    const selectedChildIds = this.get_last_child_organization_ids();

                    const uniqueOrganizations = Array.from(
                        new Map(
                            data.data.map(org => [
                                String(org.id),
                                {
                                    id: org.id,
                                    title: org.name,
                                    is_selected: selectedChildIds.includes(String(org.id)),
                                }
                            ])
                        ).values()
                    );

                    // Не push, а полная замена
                    this.all_organization = uniqueOrganizations;
                })
                .catch(({ response }) => {
                    EventBus.$emit('show_toast', {
                        err: response?.data?.message || 'Organization loading error',
                        type: 'danger',
                        title: response?.data?.status || 'Error'
                    });
                })
                .finally(() => {
                    this.is_load_all_org = false;
                });
        },

        go_start() {
            window.location.reload();
        },

        go_sync() {
            if (this.active_org.hasOwnProperty("uniq_id")) {
                this.show_feed = true;
            }
        },

        set_active_org(org, selected = true) {
            const selectedId = String(org.id);

            this.orgs.forEach((item, idx) => {
                Vue.set(
                    this.orgs[idx],
                    'is_selected',
                    selected && String(item.id) === selectedId
                );
            });
        },

        reload_sync() {
            this.orgs = [];
            this.auth_obj.isLoaded = false;
            this.auth_obj.token = null;

            this._count_stop();
            this.get_params();
        },

        async get_params() {
            let self = this;
            this.auth_obj.isRunning = true;
            this._count_start();

            this.auth_obj.step_name = this.__t('LOAD_PARAMS');
            this.orgs = [];
            this.auth_obj.token = "";

            this
                .get_token()
                .then(({data}) => {
                    if (data.status === "operation_success") {
                        self.auth_obj.token = data.data;
                    } else {
                        throw ("cant connect");
                    }

                    return this.get_active_task();
                }) .then(({data}) => {
                    console.log('active_task',data);
                    this.last_task = data.data;
                    return this.get_organizations();
                })

                .then(({data}) => {
                    self.__l(data, "info", "org_list");

                    self.orgs = [];
                    data.data.map(item => {
                        if (!item.hasOwnProperty('is_selected')) {
                            item.is_selected = false;
                            item.is_loading = false;
                        }
                        self.orgs.push(item);
                    });

                    if (self.orgs.length === 1) {
                        self.orgs.map(item => {
                            item.is_selected = true;
                            Vue.set(self.orgs, 0, item);
                        });

                       // this.go_sync();
                    }

                    this.cur_step = 'orgs_loaded';
                })

                .then(res => {
                    this.last_params = {};
                    this.get_lats_params();
                })
                .then(res => {
                    this.auth_obj.isRunning = false;
                    this.auth_obj.isLoaded = true;
                    this._count_stop();
                 })
                .catch(({response}) => {
                    this.auth_obj.token = "ERR :" + response.data.message;
                    this._count_stop();
                    this.auth_obj.isLoaded = true;
                    this.auth_obj.isRunning = false;
                    EventBus.$emit('show_toast', {
                        err: response.data.message,
                        type: "danger",
                        title: response.data.status
                    })
                })
        },

        async get_active_task() {
            return pos_api.get('/pos/' + this.prov_id + '/task/active');
        },

        async get_organizations() {
            this.auth_obj.step_name = this.__t('FETCH_ORG');
            this.auth_obj.request_cancel = api.CancelToken;

            return pos_api.get('/pos/' + this.prov_id + '/organizations', '', {
                    cancelToken: this.auth_obj.request_cancel.token
                }
            )
        },

        async get_token() {
            let self = this;
            this.auth_obj.request_cancel = api.CancelToken;

            return await pos_api.get('/pos/' + this.prov_id + '/auth', {
                    cancelToken: self.auth_obj.request_cancel.token
                }
            )
        },

        _count_start() {
            this.timer.interval = setInterval(this.incrementTime, 1000);
        },

        _count_stop() {
            clearInterval(this.timer.interval);
        },


        incrementTime() {
            this.timer.seconds = parseInt(this.timer.seconds) + 1;
        },

        cancel_auth() {

        },
    },

    computed : {

        externalMenuId: {
            get() {
                return this.external_menu_id ? String(this.external_menu_id) : null;
            },
            set(value) {
                this.external_menu_id = value ? String(value) : null;
            }
        },

        externalMenuOptions() {
            if (
                this.active_org &&
                this.active_org.hasOwnProperty('external_menu') &&
                Array.isArray(this.active_org.external_menu)
            ) {
                return this.active_org.external_menu.filter(item => item && item.id);
            }

            return [];
        },

        can_sync() {
            let has_org = this.active_org.uniq_id.length === 0;

            if (!has_org && this.has_external_menu) {
                return !this.external_menu_id;
            }

            return has_org;
        },

        has_external_menu() {
            if (this.active_org.uniq_id.length > 0) {
                if (this.active_org.hasOwnProperty("external_menu")) {
                    return true;
                }
            }
            return false;
        },


        draw_all_org() {
            if(!this.can_sync) {
                return this.all_organization.filter(item => {
                    return item.id != this.active_org.uniq_id;
                });
            }

            return [];
        },

        active_org() {
            let active = {
                "uniq_id": "",
            };
            try {
                this.worked_orgs.map(item => {
                    if (item.is_selected) {
                        active = item;
                    }
                });

            } catch (e) {
                console.log(e);
            }

            return active
        },

        prices_orgs_ids () {
            let res = [];
            if(this.show_diff_price) {
                this.draw_all_org.map(item => {
                    if(item.hasOwnProperty('is_selected')) {
                        if(item.is_selected) {
                            res.push(item.id);
                        }
                    }
                });
            }

            return res;
        },

        worked_orgs() {
            if (this.orgs.length > 0) {
                return this.orgs.map(item => {
                    if (!item.hasOwnProperty("title")) {
                        if (item.hasOwnProperty("name")) {
                            item.title = item.name;
                        }
                    }
                    return item;
                });
            }

            return [];
        },

        prov_id () {
            return parseInt(this.provider.id);
        },

        provider () {
            if(this.pos_item.hasOwnProperty('provider')) {
                return this.pos_item.provider;
            }
            return null;
        },

        is_barsi_meal() {
            console.log(this.pos_item);
            return this.pos_item.hasOwnProperty('provider') && this.pos_item.provider?.type == 'barsi-meal';
        },

        ...mapGetters({
            'pos_item': "pos/getPos",
            'is_load' : "pos/is_load",
            'user'    : 'user/getUser',
            'is_debug' : 'user/is_debug'
        }),
    }
}
</script>

<style scoped>
    .lot_org {
        display: grid;
        grid-template-columns: auto auto auto;
        padding: 10px;
    }



</style>
